import {
  validateFormat,
  validateLength,
} from 'ember-changeset-validations/validators';

export const InvitationValidation = {
  email: [validateFormat({ type: 'email' })],
  firstName: [validateLength({ max: 100, allowNone: true })],
  lastName: [validateLength({ max: 100, allowNone: true })],
};
